const ONG_CARD_STATES = {
  INITIAL: 'initial',
  CONTRIBUTION: 'contribution',
  ADD: 'add',
  EDIT: 'edit'
};

const ONG = {
  CODE: {
    DEFAULT: 'DEFAULT',
    MSF: 'MSF'
  }
};

export {
  ONG,
  ONG_CARD_STATES
};



// WEBPACK FOOTER //
// ./client/app/solidarity.module/common/domain/constants.solidarity.js